import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { debounceTime, filter, mergeMap, Observable, Subscription } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { ApiClientConstant, Table } from '@cureskin/api-client';
import { ConnectionService } from 'src/services/connection-service';
import { AppConfig } from '../../../app.config';
import { InputType } from '../../../../../typings/client/input';

@Component({
    selector: 'node-modal',
    templateUrl: './node.html',
    standalone: false
})
export class NodeModal {
  node: any;
  parentNode: any;
  types: Array<InputType.SelectOption>;
  allowedRoles: Array<Table.Role> = [];
  isFolder: boolean = true;
  public subscriptions: Subscription[] = [];
  public autoCompleteRoleController: UntypedFormControl = new UntypedFormControl();
  RoleOptions: Observable<Array<{ name: string; object: any }>>;

  static parameters: any = [AppConfig, MatDialogRef, MAT_DIALOG_DATA];
  constructor(public appConfig: AppConfig, private conn: ConnectionService, private dialogRef: MatDialogRef<NodeModal>, @Inject(MAT_DIALOG_DATA) private data: any) {}

  async ngOnInit(): Promise<void> {
    this.node = this.data.node;
    this.parentNode = this.data.parentNode;
    this.isFolder = this.node.get('type') === ApiClientConstant.EmbeddedLink.Type.Folder;
    if (this.data.node.get('allowedRoles')) {
      this.allowedRoles = this.data.node.get('allowedRoles');
    }
    await this.updateTypes();
    this.RoleOptions = this.autoCompleteRoleController.valueChanges.pipe(
      debounceTime(300),
      filter((token: string) => !!token.length),
      mergeMap((token: string) => this.getRoles(token))
    );
    this.subscriptions.push(this.dialogRef.afterOpened().subscribe((result: any) => {
      this.node.set('parentNode', this.parentNode);
      this.subscriptions.push(this.dialogRef.afterClosed().subscribe((reason: string) => {
        this.unsubscribe();
      }));
    }));
  }

  async updateTypes(): Promise<void> {
    this.types = [
      { display: 'Folder', value: ApiClientConstant.EmbeddedLink.Type.Folder },
      { display: 'Link', value: ApiClientConstant.EmbeddedLink.Type.Link },
    ];
    if (this.parentNode) {
      this.types.shift();
    }
  }

  async getRoles(token: string): Promise<Array<{ name: string; object: any }>> {
    return this.conn.getRoles({ q: token, limit: 10 })
      .then((roles: Array<Table.Role>) => {
        return roles.map((role: Table.Role) => ({
          name: role.get('name'),
          object: role,
        }));
      });
  }

  onRoleSelect(role: any): void {
    if (this.allowedRoles.find((r: Table.Role) => r.id === role.id)) {
      return;
    }
    this.allowedRoles.push(role);
    this.autoCompleteRoleController.setValue('');
  }

  removeRole(index: number): void {
    this.allowedRoles.splice(index, 1);
  }

  public unsubscribe(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  hideModal(): void {
    this.dialogRef.close();
  }

  async updateOrCreateNode(): Promise<any> {
    await this.node.save({ allowedRoles: this.allowedRoles, linkType: 'Metabase' });
    this.dialogRef.close(this.node);
  }

}
